import script from "./CustomerWithoutUser.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerWithoutUser.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__